@if (isNativeApp) {
  <div class="actions-wrapper" [ngStyle]="{ 'min-height.px': phoneActionsHeight }">
    <div class="icons-container">
      <a class="footer-icon-container" [routerLink]="['/summary']">
        <svg-icon src="assets/icons/chart-table.svg" [svgStyle]="{ 'width.px':30 }"></svg-icon>
        <p class="footer-label">
          {{ 'footer.summary' | translate }}
        </p>
      </a>
      <div class="footer-icon-container" [routerLink]="['/money/deposit']">
        <div class="summary-icon">
          <svg-icon src="assets/icons/czech-crowns.svg" [svgStyle]="{ 'width.px':27 }"></svg-icon>
        </div>
        <p class="footer-label">
          {{ 'footer.addMoney' | translate }}
        </p>
      </div>
      <div
        class="footer-icon-container"
        (click)="openModal()"
        (keydown.space)="openModal()"
        (keydown.enter)="openModal()"
        tabindex="0"
        >
        <svg-icon src="assets/icons/accountant.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
        <p class="footer-label">
          {{ 'footer.consulations' | translate }}
        </p>
      </div>
    </div>
  </div>
}


<div class="footer-container" [ngStyle]="{ 'padding-bottom.px': nativeSafeZoneService.paddings.bottom }">
  <div class="footer-max-width">
    <div class="row g-0">
      <div class="col-12 col-md-4">
        <div class="footer-logo">
          <svg-icon src="assets/logo/logo-white.svg" [svgStyle]="{ 'width.px':304 }"></svg-icon>
          <div class="logo-description">
            {{ 'login.underLogoDescription' | translate }}
          </div>
        </div>

        <div class="contacts-container">
          <div class="contact-container">
            <div class="contact-icon">
              <svg-icon src="assets/icons/phone.svg" [svgStyle]="{ 'width.px': 21 }"></svg-icon>
            </div>
            <div class="contacts-rows">
              <a class="footer-contact" href="tel:{{ 'footer.phoneNumber' | translate }}">
                {{ 'footer.phoneNumber' | translate }}
              </a>
              <div class="footer-text">
                {{ 'footer.hours1' | translate }}
              </div>
              <div class="footer-text">
                {{ 'footer.hours2' | translate }}
              </div>
            </div>
          </div>
          <div class="contact-container">
            <div class="contact-icon">
              <svg-icon src="assets/icons/envelope.svg" [svgStyle]="{ 'width.px': 23 }"></svg-icon>
            </div>
            <a class="footer-contact" href="mailto:{{ 'footer.email' | translate }}">
              {{ 'footer.email' | translate }}
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="footer-links-container">
          @for (link of footerLinks; track link) {
            @if (link.translateKey === 'consult') {
              <div
                class="footer-link"
                (click)="openModal(true)"
                [attr.data-cy]="'footer-link-' + link.translateKey"
                (keydown.space)="openModal(true)"
                (keydown.enter)="openModal(true)"
                tabindex="0"
                >
                {{ 'footer.links.consult' | translate }}
              </div>
            } @else {
              <a class="footer-link" [routerLink]="link.route" [attr.data-cy]="'footer-link-' + link.translateKey">
                {{ 'footer.links.' + link.translateKey | translate }}
              </a>
            }
          }
        </div>

        <div
          class="cookies-update phone-content"
          (click)="reopenCookieModal()"
          (keydown.space)="reopenCookieModal()"
          (keydown.enter)="reopenCookieModal()"
          tabindex="0"
          >
          {{ 'footer.links.cookiesUpdate' | translate }}
        </div>

        <div class="copyright copyright--desktop">
          <!-- todo - bad aligment -->
          &#169; {{ currentYear }} {{ 'footer.copyrightFirstRow' | translate }} {{ 'footer.copyrightSecondRow' | translate }}
        </div>

        <div
          class="cookies-update desktop-content"
          (click)="reopenCookieModal()"
          (keydown.space)="reopenCookieModal()"
          (keydown.enter)="reopenCookieModal()"
          tabindex="0"
          >
          {{ 'footer.links.cookiesUpdate' | translate }}
        </div>
      </div>

      <div class="col-12 col-md-2">
        <div class="logos-container logos-container--phone">
          <svg-icon src="assets/logo/moneco-logo-big-white.svg" [svgStyle]="{ 'width.px':87 }"></svg-icon>
          <svg-icon src="assets/logo/broker-consulting-logo-big.svg" [svgStyle]="{ 'width.px':85 }"></svg-icon>
        </div>
        <div class="logos-container logos-container--desktop">
          <svg-icon src="assets/logo/moneco-logo-big-white.svg" [svgStyle]="{ 'width.px':108 }"></svg-icon>
          <svg-icon src="assets/logo/broker-consulting-logo-big.svg" [svgStyle]="{ 'width.px':106 }"></svg-icon>
        </div>

      </div>
      <div class="copyright copyright--phone">
        <div>
          &#169; {{ currentYear }} {{ 'footer.copyrightFirstRow' | translate }}
        </div>
        <div>
          {{ 'footer.copyrightSecondRow' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
